import React from 'react';

function ProgressGraph({percentage}:{percentage:number}): React.ReactElement {

    return (
        <div>
            <div className="animated-progress w-100" style={{height:"10px",margin:"0 auto",position:"relative",background:"linear-gradient(90deg, rgba(255,107,94,1) 0%, rgba(61,196,19,1) 100%)"}}>
                <div className="" style={{width:(100 - percentage) + "%",height:"10px",backgroundColor:"#f0f8ff", float:"right"}} ></div>
            </div>
        </div>
    );
}

export default ProgressGraph;
